import { Component, Input, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FAQ } from '../../../core/models/api/app-main.model';

export interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq-accordion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq-accordion.component.html',
  styleUrls: ['./faq-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqAccordionComponent {
  @Input({ required: true }) item!: FAQ;

  isOpen = signal(false);

  toggle() {
    this.isOpen.update((v) => !v);
  }
}
